'use strict';

export default class PrizeGame {

    constructor() {
        let form = document.getElementById('prize-game-form');

        // is the element present on the current page
        if (!form) {
            return;
        }

        let input = form.querySelector('input[type="file"]'),
            label = form.querySelector('label'),
            submit = form.querySelector('#submitContestForm'),
            errorMsg = form.querySelector('.form-group__file .invalid-feedback')

        // if the form was submitted
        form.addEventListener('submit', e => {
                $('.invalid-number').hide();
                if (!$('#prize-game-form')[0].checkValidity()) {
                    e.preventDefault();

                    $('input').each(function () {

                        if (!this.checkValidity()) {
                            $(this).parent().addClass('has-errors');

                            // Checkbox
                            $(this).siblings('.invalid-feedback').slideDown();

                            // Other elements
                            $(this).parent().siblings('.invalid-feedback').slideDown();
                        } else {
                            $(this).parent().removeClass('has-errors');
                            $(this).parent().siblings('.invalid-feedback').slideUp();
                            $(this).siblings('.invalid-feedback').slideUp();
                        }
                    });
                } else {
                    e.preventDefault();

                    ga('send', 'event', 'mk-prize-page', 'form-sent', 'webpage');
                    var ajaxData = new FormData();

                    ajaxData.append('action', 'prize_game_form');
                    ajaxData.append('number', $('.form #number').val());
                    ajaxData.append('id', $('.form #id').val());
                    ajaxData.append('hour', $('.form #hour').val());
                    ajaxData.append('name', $('.form #name').val());
                    ajaxData.append('last', $('.form #last').val());
                    ajaxData.append('email', $('.form #email').val());
                    ajaxData.append('phone', $('.form #phone').val());
                    ajaxData.append('nonce', $('.form #nonce').val());

                    $.ajax({
                        url: ajaxurl,
                        data: '/wp/wp-admin/admin-ajax.php',
                        processData: false,
                        contentType: false,
                        type: 'POST',
                        success: function (data) {
                            $('.prize__form').hide();
                            document.querySelector('.logo').style.backgroundImage = 'url(/app/themes/argeta-timber/dist/images/svg/logo-argeta-orange.svg)';
                            $('.prize__confirmation').show();

                            ga('send', 'event', 'mk-prize-page', 'form-success', 'webpage');

                            $([document.documentElement, document.body]).animate({
                                scrollTop: 0
                            }, 1000);
                        },
                        error: function () {
                            $('.invalid-number').slideDown();
                        }
                    });
                }
        });

    }
}
